import slugify from '@sindresorhus/slugify'

/** One DNS label: the slug is the tenant's subdomain. */
const MAX_SLUG_LENGTH = 63

/** A slug proposal from a tenant name; the user can still edit it. */
export function suggestSlug(name: string) {
  return (
    slugify(name, {
      // `GmbH` stays one word instead of `gmb-h`
      decamelize: false,
      // `Müller & Söhne` → `mueller-soehne`, not `mueller-and-soehne`
      customReplacements: [['&', ' ']],
    })
      // the cut may leave a trailing hyphen
      .slice(0, MAX_SLUG_LENGTH)
      .replace(/-+$/, '')
  )
}
